import React, { } from "react";
// import { Row, Col, InputGroup, DropdownButton, FormControl, Dropdown } from 'react-bootstrap';
// import { X } from 'react-bootstrap-icons';
import { useDispatch } from 'redux-react-hook';

export default function QuestionOptInputText(props) {
    const data = props.data;
    const questionIndex = props.index;
    const dispatch = useDispatch();

    // useEffect(() => {
    //     if (isEditing) {
    //       inputRef.current.focus();
    //     }
    //   }, [isEditing]);

    function handleKeyPress(e) {
        const char = e.charCode;
        // console.log(char);
        if (13 == char) { //enter
            dispatch({ type: "ON_ADD_TMP_OPTION", index: questionIndex });
        }
    }

    function render() {
        if (props.isDisabled) {
            return (
                <input type="text" className="w-100 underline" value={data} disabled />
            );
        }
        return (
            <input type="text" className="w-100 underline" value={data} onChange={props.onChange} onKeyPress={handleKeyPress} />
        );
    }

    return render();
}